import { render, staticRenderFns } from "./PerformanceComparisonDouble.vue?vue&type=template&id=be61d2a2&scoped=true"
import script from "./PerformanceComparisonDouble.vue?vue&type=script&lang=ts"
export * from "./PerformanceComparisonDouble.vue?vue&type=script&lang=ts"
import style0 from "./PerformanceComparisonDouble.vue?vue&type=style&index=0&id=be61d2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61d2a2",
  null
  
)

/* custom blocks */
import block0 from "./PerformanceComparisonDouble.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyEsgSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgSectionTitle.vue').default,EsgPerformanceComparisonProgressBarDouble: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/PerformanceComparisonProgressBarDouble.vue').default,EsgPortfolioDifferenceColumn: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/PortfolioDifferenceColumn.vue').default})
